// extracted by mini-css-extract-plugin
export default {"link":"blog_link__+XEMW","pagination":"blog_pagination__7kZwD","container":"blog_container__KCW0p","wrapper":"blog_wrapper__zrmCL"};